import type { Site } from '@/api/fe-api/domain/entities/site';
import { useMe } from '@/hooks/use-me';
import { formatEnergy, formatPower } from '@/utils/format/battery';

export type PowerEnergyProps = {
  site: Pick<Site, 'nominalPowerW' | 'nominalEnergyWH'>;
  className?: string;
};
export function PowerEnergy({ site, className }: PowerEnergyProps) {
  const me = useMe();

  if (!site?.nominalPowerW && !site?.nominalEnergyWH) {
    return null;
  }

  return (
    <div className={className}>{`${
      site.nominalPowerW
        ? formatPower(site.nominalPowerW, me.config.powerUnit, 0)
        : '-'
    } / ${
      site.nominalEnergyWH
        ? formatEnergy(site.nominalEnergyWH, me.config.powerUnit, 0)
        : '-'
    }`}</div>
  );
}
